import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ApiService } from '../services/api.service';
import { UtilitiesService } from '../services/utilities.service';
import Swal from 'sweetalert2'

@Component({
    selector: 'app-offers',
    templateUrl: './offers.component.html',
    styleUrls: ['./offers.component.css'],
    standalone: false
})
export class OffersComponent implements OnInit {
  page = 1;
  pageSize = 50;

  list_length = 0;
  items: any[] = [];
  token: any;

  item = {
    name: null,
    type: 'PUBLIC',
    percentage: null,
    start_date: null,
    end_date: null
  }
  new_item = {
    name: null,
    type: 'PUBLIC',
    percentage: null,
    start_date: null,
    end_date: null
  }

  update_key: any;
  Swal = 'sweetalert2'

  constructor(public utility: UtilitiesService, private api: ApiService, private modalService: NgbModal, private titleService: Title) {
    this.utility.show = true;
    this.token = localStorage.getItem('access_token');
  }

  ngOnInit(): void {
    this.titleService.setTitle('Offers Definition');
    this.getOffers();
  }

  open(content: any) {
    this.modalService.open(content);
  }

  edit(content: any, item: any) {
    this.update_key = item.id;
    this.new_item = item;

    this.modalService.open(content);
  }

  async getOffers() {
    const sub = this.api.get('offers/', this.token).subscribe(
      async data => {
        let objects: any = {}
        objects = data;

        this.items = objects;
        this.list_length = this.items.length;
      },
      async error => { }
    );

    sub.add(() => { });
  }

  async getServices() {
    this.api.get('offers/avaliable', this.token).subscribe(
      async data => {
        let objects: any = {}
        objects = data;
      },
      async error => { }
    );
  }

  async OnSubmit() {
    let body = {
      'name': this.item.name,
      'type': this.item.type,
      'percentage': this.item.percentage,
      'start_date': this.item.start_date,
      'end_date': this.item.end_date
    }

    this.api.post("offers/", body, this.token).subscribe(
      async data => {
        this.getOffers();
        Swal.fire({
          title: 'Success!',
          text: 'Added Successfuly!',
          icon: 'success',
          confirmButtonText: 'Cool'
        })
      },
      async error => {
        Swal.fire({
          title: 'Error!',
          text: 'Something went wrong!',
          icon: 'error',
          confirmButtonText: 'Ok'
        });
      }
    );

    this.modalService.dismissAll();
  }

  async OnUpdate(key: any) {
    let body = {
      'name': this.new_item.name,
      'type': this.new_item.type,
      'percentage': this.new_item.percentage,
      'start_date': this.new_item.start_date,
      'end_date': this.new_item.end_date
    }

    this.api.update("offers/" + key, body, this.token).subscribe(
      async data => {
        this.getOffers();
        Swal.fire({
          title: 'Success!',
          text: 'Updated Successfuly!',
          icon: 'success',
          confirmButtonText: 'Cool'
        })
      },
      async error => {
        Swal.fire({
          title: 'Error!',
          text: 'Something went wrong!',
          icon: 'error',
          confirmButtonText: 'Ok'
        });
      }
    );

    this.modalService.dismissAll();
  }

  async onDelete(key: any) {
    if (confirm("Delete this item?")) {
      this.api.delete('offers/' + key, this.token).subscribe(
        async data => {
          this.getOffers();
          Swal.fire({
            title: 'Success!',
            text: 'Deleted Successfuly!',
            icon: 'success',
            confirmButtonText: 'Cool'
          })
        },
        async error => {
          Swal.fire({
            title: 'Error!',
            text: 'Something went wrong!',
            icon: 'error',
            confirmButtonText: 'Ok'
          });
        }
      );
    }
  }
}
